import React from 'react'
import { Toast } from '@sukiai/components'
import { compose, graphql } from 'react-apollo'
import { GET_TOAST, CLEAR_TOAST } from '../apollo/actions'

const ToastContainer = ({
  type,
  message,
  duration,
  shouldDismiss,
  clearToast
}) => (
  <Toast
    type={type}
    message={message}
    duration={duration}
    shouldDismiss={shouldDismiss}
    onDismiss={clearToast}
  />
)

export default compose(
  graphql(GET_TOAST, {
    props: ({ data: { toast } }) => {
      const { type, message, duration, shouldDismiss } = toast
      return { type, message, duration, shouldDismiss }
    }
  }),
  graphql(CLEAR_TOAST, { name: 'clearToast' })
)(ToastContainer)
